module.exports = __webpack_public_path__ + "static/img/case_11.908f92f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_11.jpg
// module id = qgqL
// module chunks = 0